<template>
  <span :class="[
    'currency-wrapper',
    $props.classes
  ]"
  > {{currencyText}} <slot></slot></span>
</template>
<script>

export default {
  name: 'currencyWrapper',
  computed: {
    currencyCode() {
      return this.$store.state.utils.queryParams.currencyCode;
    },
    canvasActive() {
      return this.$store.getters["utils/canvasActive"];
    },
  },
  props: {
    priceRaw: {
      type: String,
      required: true
    },
    classes: {
      type: String,
      default: ''
    }
  },
  watch: {
    priceRaw: {
      immediate: true,
      handler: 'updateCurrencyText',
    }
  },
  data() {
    return {
      currencyText: ''
    }
  },
  methods: {
    /**
     * @function updateCurrencyText
     * Gets the currency code from the price string and replace it with the
     * currency code that come from the queryParam if the app has vsfActive.
     * Otherwise, it just diplay the price.
     */
    updateCurrencyText() {
      if (typeof this.currencyCode !== 'undefined' && this.canvasActive) {
        const priceText  = this.$store.state.buyPanel.price.string || '';
        const regex = /[^0-9]*/;
        const toReplace = priceText.match(regex)[0].trim();
        this.currencyText = this.priceRaw.replace(toReplace, `${this.currencyCode}`);
        // update special use case for KR currency
        if(this.currencyCode.includes('kr')) {
          this.currencyText = `${this.currencyText.replace(this.currencyCode,'')} ${this.currencyCode}`;
        }
      } else {
        this.currencyText = this.priceRaw;
      }
    }
  }
}

</script>